export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ05.c200545d.mp3";